var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134.986,
    height: 129.634,
    viewBox: "0 0 134.986 129.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10793",
    "data-name": "Group 10793",
    transform: "translate(-2574.538 -1172.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M38.066,0c26.867,0,69.4,29.5,69.4,56.366s-5.687,57.869-35.363,57.869S0,86.042,0,56.366,11.2,0,38.066,0Z",
    transform: "translate(2687.846 1173.893) rotate(79)",
    fill: "none",
    stroke: "#ffdce1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M38.066-1.666c26.867,0,69.4,29.5,69.4,56.366S101.78,112.569,72.1,112.569,0,84.376,0,54.7,11.2-1.666,38.066-1.666Z",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 2582.796, 1188.006)",
    fill: "#ffe6ea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10787",
    "data-name": "Group 10787",
    transform: "translate(734.454 312.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M21.771,3.447a4.843,4.843,0,0,0-8.418,0L.606,26.157a4.651,4.651,0,0,0,.042,4.667A4.777,4.777,0,0,0,4.815,33.2H30.308a4.777,4.777,0,0,0,4.166-2.372,4.651,4.651,0,0,0,.042-4.667Zm-4.209,23.9a1.463,1.463,0,1,1,1.463-1.463A1.463,1.463,0,0,1,17.562,27.342Zm1.463-7.317a1.463,1.463,0,0,1-2.927,0V11.244a1.463,1.463,0,0,1,2.927,0Z",
    transform: "translate(1890.015 917.994)",
    fill: "#ff586d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "riskmerter_2",
    transform: "translate(1894.812 898.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M7.063,125.05a8.058,8.058,0,0,1,0-11.4L3.74,110.325a12.756,12.756,0,0,0,0,18.049.748.748,0,0,0,1.056,0l2.265-2.265a.748.748,0,0,0,0-1.056Z",
    transform: "translate(0 -106.585)",
    fill: "#00d200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M88.889,39.052a12.756,12.756,0,0,0-18.048,0,.748.748,0,0,0,0,1.056l2.267,2.266a.748.748,0,0,0,1.056,0,8.058,8.058,0,0,1,11.4,0,.748.748,0,0,0,1.056,0l2.265-2.265a.748.748,0,0,0,0-1.056Z",
    transform: "translate(-67.102 -35.311)",
    fill: "#ffaa32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M265.024,39.051A12.68,12.68,0,0,0,256,35.311v4.7a8.01,8.01,0,0,1,5.7,2.362.748.748,0,0,0,1.056,0l2.265-2.265a.748.748,0,0,0,0-1.056Z",
    transform: "translate(-243.235 -35.311)",
    fill: "#ffaa32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M366.167,125.05a8.058,8.058,0,0,0,0-11.4l3.323-3.323a12.757,12.757,0,0,1,0,18.049.748.748,0,0,1-1.056,0l-2.265-2.265a.748.748,0,0,1,0-1.056Z",
    transform: "translate(-347.702 -106.585)",
    fill: "#ff1e5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M4.7,119.348a8.01,8.01,0,0,1,2.363-5.7L3.74,110.325A12.679,12.679,0,0,0,0,119.349Z",
    transform: "translate(0 -106.585)",
    fill: "#00d200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M366.166,296.981a8.019,8.019,0,0,0,2.363-5.7h4.7a12.679,12.679,0,0,1-3.74,9.024.748.748,0,0,1-1.056,0l-2.265-2.265A.748.748,0,0,1,366.166,296.981Z",
    transform: "translate(-347.701 -278.516)",
    fill: "#ff1e5a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "matrix(-0.978, 0.208, -0.208, -0.978, 22.134, 17.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M8.641,8.641a2.353,2.353,0,0,1-3.324,0,86.014,86.014,0,0,1-5.2-7.492A.748.748,0,0,1,1.149.117a85.894,85.894,0,0,1,7.491,5.2,2.353,2.353,0,0,1,0,3.324Z",
    transform: "translate(0 9.157) rotate(-79)",
    fill: "#003c50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M8.422,8.641,0,.219a.748.748,0,0,1,.93-.1,85.894,85.894,0,0,1,7.491,5.2,2.353,2.353,0,0,1,0,3.324Z",
    transform: "translate(0.042 8.942) rotate(-79)",
    fill: "#001428"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirus);
export default __webpack_public_path__ + "static/media/virus.3686c3f6273520117988c9c49a3eace2.svg";
export { ForwardRef as ReactComponent };